module.exports = __webpack_public_path__ + "static/card-back-3-811b2d42f4b614503cd934f4e85e39bb.png";